module.exports={author:"Sean Singer",date:"08/26/2021",publishDate:"08/26/2021",highlighted:!1,tags:"",title:"Orange Bottles"};